'use strict';

var pink$1 = require('../../../../_virtual/pink.js_commonjs-exports.js');

Object.defineProperty(pink$1.__exports, "__esModule", {
  value: true
});
pink$1.__exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
pink$1.__exports.default = _default;
